import axios, { AxiosError } from "axios";
import { serializeQueryParams } from "@/helpers/serializeQueryParams";
import { ApiErrorResponse } from "@/types/api";

//! Base Settings for axios
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
  paramsSerializer: serializeQueryParams,
});

export const apiFormData = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
  withCredentials: true,
});


let unauthorizedHandler: (() => void) | null = null;

export const setUnauthorizedHandler = (handler: () => void) => {
  unauthorizedHandler = handler;
};

const handleUnauthorized = (error: AxiosError) => {
  const status = error.response?.status;
  if (status === 401) {
    try {
      unauthorizedHandler?.();
    } catch (e) {
      // Avoid breaking the interceptor chain due to handler errors
      console.error("Unauthorized handler error", e);
    }
  }
  return Promise.reject(error);
};

api.interceptors.response.use((res) => res, handleUnauthorized);
apiFormData.interceptors.response.use((res) => res, handleUnauthorized);

export const extractApiErrorMessage = (error: AxiosError): string => {
  if (error.response?.data) {
    const body = error.response.data as ApiErrorResponse;
    if (Array.isArray(body.data) && body.data.length > 0) {
      return body.data.join("\n");
    }
    if (body.error) {
      return body.error;
    }
  }

  if (!error.response) {
    return "Errore di connessione. Verificare la connessione internet.";
  }

  return "Si è verificato un errore tecnico";
};

export const decodeApiError = (error: AxiosError) => {
  console.error(`Errore API. Status=${error.status}`);
  if (error.request) {
    console.error("Follow the request:");
    console.error(error.request);
  }
  if (error.response) {
    console.log(error.response.data);
  }
  return extractApiErrorMessage(error);
};
